module.exports = __webpack_public_path__ + "static/media/m_eyeshape_round_amber.01ba39c5.png";